import React, { Suspense, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import Footer from '@/components/organisms/Footer/Footer'
import Header from '@/components/organisms/Header/Header'

interface ErrorWrapperProps {
  title: string
  errorCode: string
  subtitle?: string
  description?: string
  children?: ReactNode
  isError?: boolean
}

export const ErrorWrapper: React.FC<ErrorWrapperProps> = ({
  title,
  errorCode,
  subtitle,
  description,
  children,
  isError = true
}) => {
  return (
    <div className='min-h-screen flex flex-col overflow-hidden'>
      <Suspense fallback={<LoadingLogo />}>
        <Header isError={isError} />
        <main className='flex-grow p-4'>
          <div className='flex flex-col lg:flex-row items-center justify-between container lg:max-w-[1220px] p-0 mt-8'>
            <div className='w-full flex gap-4 flex-col justify-end items-center pt-12 pb-12'>
              <div className='w-full flex justify-end'>
                <h2 className='text-[#E9E9E9] text-[12vw] lg:text-[150px] leading-none'>
                  {title}
                </h2>
              </div>
              <h1 className='text-[#D9EEFF] text-[30vw] lg:text-[400px] font-bold leading-none lg:leading-[300px]'>
                {errorCode}
              </h1>
              {subtitle !== null && <h3 className='text-2xl mb-2'>{subtitle}</h3>}
              {description !== null && <p className='mb-4'>{description}</p>}
              <div className='w-full flex justify-start text-[5vw] lg:text-[22px] hover:text-secondary underline'>
                <Link to='/'>Go to home</Link>
              </div>
              {children}
            </div>
          </div>
        </main>
        <Footer isError={isError} />
      </Suspense>
    </div>
  )
}
